const TOKEN_KEY = 'achievements_jwt_token'

const decodeToken = token => {
  try {
    const payload = token.split('.')[1]
    return JSON.parse(atob(payload))
  } catch {
    return null
  }
}

const isTokenExpired = token => {
  const decoded = decodeToken(token)
  if (!decoded?.exp) return true
  return Date.now() >= decoded.exp * 1000
}

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return null
  if (isTokenExpired(token)) {
    localStorage.removeItem(TOKEN_KEY)
    return null
  }
  return token
}

export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const getUserFromToken = () => {
  const token = getToken()
  if (!token) return null
  return decodeToken(token)
}

export { decodeToken, isTokenExpired, TOKEN_KEY }
